export default class Modal {


	show(options={})
	{
  		return Swal.fire(options); 
	}

	/**
	 * Show an error modal
	 */
	error(title, text, btn) 
	{
  		const icon = 'error';
  		
  		return this.show({title:title, text:text, confirmButtonText:btn, icon:icon, showCancelButton: false});
	}

	/**
	 * Show a success modal
	 */
	success(title, text, btn) 
	{ 
  		const icon = 'success';
  		
  		return this.show({title:title, text:text, confirmButtonText:btn, icon:icon, showCancelButton: false});
	}

	/**
	 * Show a warning modal
	 */
	warning(title, text, btn) 
	{ 
  		const icon = 'warning';
  		
  		return this.show({title:title, text:text, confirmButtonText:btn, icon:icon, showCancelButton: false});
	}

	/**
	 * Show an informational modal
	 */
	info(title, text, btn) 
	{ 
 	 	const icon = 'info';
 	 	
  		return this.show({title:title, text:text, confirmButtonText:btn, icon:icon, showCancelButton: false});
	}

}